import { render, staticRenderFns } from "./WorkflowTransitionDetailDrawer.vue?vue&type=template&id=6fc63d54&"
import script from "./WorkflowTransitionDetailDrawer.vue?vue&type=script&lang=ts&"
export * from "./WorkflowTransitionDetailDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports